import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  NumberInput,
  NumberInputField,
  Button,
  SimpleGrid,
  useToast,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
interface TipoConstruccion {
  id: number;
  idTipo: string;
  calidad: string;
  habilitado: boolean;
}

interface EstadoConservacion {
  id: string;
  descripcion: string;
  factor: string;
  habilitado: boolean;
}

interface FactorDemerito {
  id: number;
  descripcion: string;
  grupo: string;
  aplica: string;
  limiteInferior: string;
  limiteSuperior: string;
  factor: string;
  uso: string | null;
  habilitado: boolean;
}

interface Construccion {
  id?: number;
  idClaveCatastral: number;
  idTipoConstruccion: number;
  idEstadoConservacion: string;
  idFactorTerminacion: number;
  idFactorEdad: number;
  areaConstruccion: number;
  bloque: number;
  valorConstruccion: number;
  a_oEdificacion: number;
  fechaActualizacion:Date;
  avanceObra: number; // Nuevo campo añadido
  factorResultante: number;
  usuario: string;
  valorConstruccionComercial: number;
}

const ConstruccionForm: React.FC<{ idClaveCatastral: number }> = ({ idClaveCatastral }) => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [tipoConstrucciones, setTipoConstrucciones] = useState<TipoConstruccion[]>([]);
  const [estadoConservaciones, setEstadoConservaciones] = useState<EstadoConservacion[]>([]);
  const [factoresDemerito, setFactoresDemerito] = useState<FactorDemerito[]>([]);

  const [construcciones, setConstrucciones] = useState<Construccion[]>([]);
  const [newConstruccion, setNewConstruccion] = useState<Construccion>({
    idClaveCatastral,
    idTipoConstruccion: 0,
    idEstadoConservacion: "",
    idFactorTerminacion: 0,
    idFactorEdad: 0,
    areaConstruccion: 0,
    bloque: 0,
    valorConstruccion: 0,
    a_oEdificacion: new Date().getFullYear(),
    fechaActualizacion: new Date(),
    avanceObra: 0, // Inicializamos el nuevo campo
    factorResultante: 0,
    usuario: user.name,
    valorConstruccionComercial: 0,
  });

  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const toast = useToast();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [construccionesResponse, tipoConstruccionesResponse, estadoConservacionesResponse,factoresDemeritoResponse] = await Promise.all([
          axios.get(`http://52.91.130.91:5000/api/construccionRoutes/${idClaveCatastral}`),
          axios.get("http://52.91.130.91:5000/api/cTipoConstruccionRoutes"),
          axios.get("http://52.91.130.91:5000/api/cEstadoConservacionRoutes"),
          axios.get("http://52.91.130.91:5000/api/cFactorDemeritoRoutes"),

        ]);

        setConstrucciones(construccionesResponse.data);
        setTipoConstrucciones(tipoConstruccionesResponse.data.filter((item: TipoConstruccion) => item.habilitado));
        setEstadoConservaciones(estadoConservacionesResponse.data.filter((item: EstadoConservacion) => item.habilitado));
        setFactoresDemerito(
          factoresDemeritoResponse.data.filter((factor: FactorDemerito) => factor.habilitado)
        );
      } catch {
        toast({
          title: "Error",
          description: "No se pudieron cargar los datos iniciales.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchData();
  }, [idClaveCatastral, toast]);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setNewConstruccion((prev) => ({
      ...prev,
      [name]: isNaN(Number(value)) ? value : Number(value),
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      if (editingIndex !== null) {
        // Actualizar construcción existente
        const updated = await axios.put(
          `http://52.91.130.91:5000/api/construccionRoutes/${newConstruccion.id}`,
          newConstruccion
        );
        setConstrucciones((prev) => {
          const updatedList = [...prev];
          updatedList[editingIndex] = updated.data;
          return updatedList;
        });
        toast({
          title: "Éxito",
          description: "Construcción actualizada correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        // Crear nueva construcción
        const created = await axios.post("http://52.91.130.91:5000/api/construccionRoutes", newConstruccion);
        setConstrucciones((prev) => [...prev, created.data]);
        toast({
          title: "Éxito",
          description: "Construcción agregada correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }

      // Resetear el formulario
      setNewConstruccion({
        idClaveCatastral,
        idTipoConstruccion: 0,
        idEstadoConservacion: "",
        fechaActualizacion:new Date(),
        idFactorTerminacion: 0,
        idFactorEdad: 0,
        areaConstruccion: 0,
        bloque: 0,
        valorConstruccion: 0,
        a_oEdificacion: new Date().getFullYear(),
        avanceObra: 0,
        factorResultante: 0,
        usuario: user.name,
        valorConstruccionComercial: 0,
      });
      setEditingIndex(null);
    } catch {
      toast({
        title: "Error",
        description: "No se pudo guardar la construcción.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleEdit = (index: number) => {
    setEditingIndex(index);
    setNewConstruccion(construcciones[index]);
  };

  const handleDelete = async (id?: number) => {
    if (id) {
      try {
        await axios.delete(`http://52.91.130.91:5000/api/construccionRoutes/${id}`);
        setConstrucciones((prev) => prev.filter((c) => c.id !== id));
        toast({
          title: "Éxito",
          description: "Construcción eliminada correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } catch {
        toast({
          title: "Error",
          description: "No se pudo eliminar la construcción.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <Box p={[2, 4, 6]} maxW="1200px" mx="auto">
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
        <FormControl>
            <FormLabel>Tipo de Construcción</FormLabel>
            <Select
              name="idTipoConstruccion"
              value={newConstruccion.idTipoConstruccion}
              onChange={handleChange}
              placeholder="Seleccione un tipo"
              isRequired
            >
              {tipoConstrucciones.map((tipo) => (
                <option key={tipo.id} value={tipo.id}>
                  {tipo.calidad}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Estado de Conservación</FormLabel>
            <Select
              name="idEstadoConservacion"
              value={newConstruccion.idEstadoConservacion}
              onChange={handleChange}
              placeholder="Seleccione un estado"
              isRequired
            >
              {estadoConservaciones.map((estado) => (
                <option key={estado.id} value={estado.id}>
                  {estado.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Área de Construcción</FormLabel>
            <NumberInput
              value={newConstruccion.areaConstruccion}
              onChange={(value) =>
                setNewConstruccion((prev) => ({
                  ...prev,
                  areaConstruccion: parseFloat(value) || 0,
                }))
              }
            >
              <NumberInputField name="areaConstruccion" />
            </NumberInput>
          </FormControl>

            {/* Campo Factor Terminación */}
            <FormControl>
            <FormLabel>Factor Terminación</FormLabel>
            <Select
              name="idFactorTerminacion"
              value={newConstruccion.idFactorTerminacion}
              onChange={handleChange}
              placeholder="Seleccione un factor"
              isRequired
            >
              {factoresDemerito
                .filter((factor) => factor.grupo === "AVANCE DE OBRA") // Filtrar por grupo específico
                .map((factor) => (
                  <option key={factor.id} value={factor.id}>
                    {factor.descripcion}
                  </option>
                ))}
            </Select>
          </FormControl>

          {/* Campo Factor Edad */}
          <FormControl>
            <FormLabel>Factor Edad</FormLabel>
            <Select
              name="idFactorEdad"
              value={newConstruccion.idFactorEdad}
              onChange={handleChange}
              placeholder="Seleccione un factor"
              isRequired
            >
              {factoresDemerito
                .filter((factor) => factor.grupo === "EDAD") // Filtrar por grupo específico
                .map((factor) => (
                  <option key={factor.id} value={factor.id}>
                    {factor.descripcion} {factor.limiteInferior}-{factor.limiteSuperior}
                  </option>
                ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Año de Edificación</FormLabel>
            <Input
              name="a_oEdificacion"
              value={newConstruccion.a_oEdificacion}
              onChange={handleChange}
              type="number"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Valor de Construcción</FormLabel>
            <Input
              name="valorConstruccion"
              value={newConstruccion.valorConstruccion}
              onChange={handleChange}
              type="number"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Factor Resultante</FormLabel>
            <Input
              name="factorResultante"
              value={newConstruccion.factorResultante}
              onChange={handleChange}
              type="number"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Valor Comercial</FormLabel>
            <Input
              name="valorConstruccionComercial"
              value={newConstruccion.valorConstruccionComercial}
              onChange={handleChange}
              type="number"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Usuario</FormLabel>
            <Input
              name="usuario"
              value={newConstruccion.usuario}
              onChange={handleChange}
              placeholder="Usuario"
              isDisabled
            />
          </FormControl>
        </SimpleGrid>

        <Button type="submit" colorScheme="blue" mt={4}>
          {editingIndex !== null ? "Actualizar Construcción" : "Agregar Construcción"}
        </Button>
      </form>

      <Table variant="simple" mt={8}>
        <Thead>
          <Tr>
            <Th>Tipo</Th>
            <Th>Área</Th>
            <Th>Estado</Th>
            <Th>Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {construcciones.map((construccion, index) => (
            <Tr key={construccion.id}>
              <Td>{construccion.idTipoConstruccion}</Td>
              <Td>{construccion.areaConstruccion}</Td>
              <Td>{construccion.idEstadoConservacion}</Td>
              
              <Td>
                <Button size="sm" colorScheme="green" onClick={() => handleEdit(index)}>
                  Editar
                </Button>
                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={() => handleDelete(construccion.id)}
                  ml={2}
                >
                  Eliminar
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ConstruccionForm;
